export var PlayerLoadingTimeout;
(function (PlayerLoadingTimeout) {
    PlayerLoadingTimeout[PlayerLoadingTimeout["NETWORK"] = 15000] = "NETWORK";
    PlayerLoadingTimeout[PlayerLoadingTimeout["VAST"] = 8000] = "VAST";
    PlayerLoadingTimeout[PlayerLoadingTimeout["AD"] = 8000] = "AD";
})(PlayerLoadingTimeout || (PlayerLoadingTimeout = {}));
